import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ReviewReportList from 'components/ReviewReport/List';

const ScreenReviewReportList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ReviewReportList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};

export default ScreenReviewReportList;
